module.exports = __webpack_public_path__ + "img/qrcode.71d6698b.png";